module.exports = __webpack_public_path__ + "static/gothamhtf-thin-c385d3d29eb5ede4e9892e223ad45de1.woff2";